import { Component, Input } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';

@Component({
  selector: 'app-active-inactive-tag',
  templateUrl: './active-inactive-tag.component.html',
  standalone: false,
})
export class ActiveInactiveTagComponent extends AppBaseComponent {

  @Input({ required: true }) isActive: boolean;

}
